var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-workspaces"},[(_vm.user.workspaces)?_c('Table',{attrs:{"title":"User's Workspaces","rows":_vm.user.workspaces,"fields":_vm.fields,"collapsed":""},on:{"rowClick":_vm.onRowClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }